import cloneDeep from 'lodash/cloneDeep';

import AddProcedurePopup from '@/components/popups/AddProcedurePopUp/AddProcedurePopup';
import { PopupDocument } from '@/components/popups/AddProcedurePopUp/types';

import { useCategories } from '../data';

import { useFocusAdminState } from '@/routes/Admin/state';
import { useAdminManagingCountry } from '@/routes/Admin/useAdminManagingCountry';

const AddProcedure: React.FC = () => {
  const { showAddProcedurePopUp, setShowAddProcedurePopUp } =
    useFocusAdminState('showAddProcedurePopUp');

  const { temporaryCategory, setTemporaryCategory } =
    useFocusAdminState('temporaryCategory');

  const { selectedSubcategoryIndex, setSelectedSubcategoryIndex } =
    useFocusAdminState('selectedSubcategoryIndex');
  const { selectedSubtitleIndex, setSelectedSubtitleIndex } =
    useFocusAdminState('selectedSubtitleIndex');

  const { selectedCountry } = useAdminManagingCountry();

  // Maintains subscription to categories query for proper query invalidation behavior
  useCategories();

  const handleAddProcedureToSubtitleClose = () => {
    setShowAddProcedurePopUp(false);
  };

  const handleAdminAddProcedure = async (
    selectedDocuments: PopupDocument[],
  ) => {
    const clonedCategory = cloneDeep(temporaryCategory);

    // @ts-expect-error subtitles array index access not typed correctly
    clonedCategory.subcategories[selectedSubcategoryIndex].subtitles[
      selectedSubtitleIndex
    ].documents =
      // @ts-expect-error subtitles array index access not typed correctly
      clonedCategory.subcategories[selectedSubcategoryIndex].subtitles[
        selectedSubtitleIndex
      ].documents.concat(selectedDocuments);

    setSelectedSubcategoryIndex(-1);
    setSelectedSubtitleIndex(-1);

    setTemporaryCategory(clonedCategory);
    setShowAddProcedurePopUp(false);
  };

  return (
    <AddProcedurePopup
      adminAddingProcedure
      isOpen={showAddProcedurePopUp}
      onCustomAddProcedure={handleAdminAddProcedure}
      onClose={handleAddProcedureToSubtitleClose}
      selectedCountryCode={selectedCountry.label}
    />
  );
};

export default AddProcedure;
